import { useState, useCallback } from "react";
import { getBrowserScrollbarWidth, hideIntercom, showIntercom, deactivateScrollbar, reactivateScrollbar } from '../components/common/helpers.js';

const useModal = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);
    const openModal = useCallback(() => {
        const scrollbarWidth = getBrowserScrollbarWidth();
        deactivateScrollbar(scrollbarWidth);
        hideIntercom();
    setIsOpen(true);
  }, []);

    const closeModal = useCallback(() => {
        reactivateScrollbar();
        showIntercom();
    setIsOpen(false);
  }, []);

  const toggleModal = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
  };
};

export default useModal;
